import { useContext, useState } from 'react';

import { showSnackbar } from 'helpers/snackbar';

import { media } from 'context';
import { ComboBox, Layout, Text } from 'ds';
import { filterByInclusion } from 'shared/filter';
import { ConsumablesProduct, DraftConsumablesOrderItem, DraftConsumablesProductSubscription } from 'shared/types';
import { selectProducts } from 'store/Consumables/selectors';
import { useAppSelector } from 'store/hooks';

import ConsumablesProductResult from './ConsumablesProductResult';

interface ConsumablesAddProductsComboBoxProps {
  onSelect: (result: any) => void;
  existingProductSelections: (DraftConsumablesProductSubscription | DraftConsumablesOrderItem)[];
}
const ConsumablesAddProductsComboBox = ({
  onSelect,
  existingProductSelections
}: ConsumablesAddProductsComboBoxProps) => {
  const products = useAppSelector(selectProducts);
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState<boolean>(false);
  const { isMobile } = useContext(media);

  const [query, setQuery] = useState('');

  const resultProducts: ConsumablesProduct[] = query
    ? products
        .filter(
          product => !existingProductSelections.some(selection => selection.consumables_product.id === product.id)
        )
        .filter(
          product =>
            filterByInclusion(product.brand, query) ||
            filterByInclusion(`${product.brand} ${product.detail} ${product.unit_type}`, query) ||
            filterByInclusion(product.detail, query) ||
            filterByInclusion(product.unit_type, query) ||
            filterByInclusion(product.package_type, query) ||
            filterByInclusion((product.amount_cents / 100).toString(), query)
        )
    : products.filter(
        product => !existingProductSelections.some(selection => selection.consumables_product.id === product.id)
      );

  const results = resultProducts.map(product => ({
    value: product.id,
    element: <ConsumablesProductResult product={product} query={query} />
  }));

  return (
    <ComboBox
      setIsBottomSheetVisible={setIsBottomSheetVisible}
      isBottomSheetVisible={isBottomSheetVisible}
      setQuery={setQuery}
      query={query}
      icon="search"
      noMatchesItem={
        query.length > 0 && results.length === 0 ? (
          <Layout flex paddingLeft={24}>
            <Text size="body-md" color="gray-400">
              No results to show.
            </Text>
          </Layout>
        ) : undefined
      }
      isBottomSheet={isMobile}
      customMobileTextInput={
        <input
          autoFocus={true}
          value={query}
          type="text"
          style={{
            width: '80%',
            border: 'none',
            outline: 'none',
            height: '24px'
          }}
          placeholder="Add products"
          onChange={e => {
            setQuery(e.target.value);
            onSelect(undefined);
          }}
        />
      }
      size="sm"
      maxItems={results.length}
      maxVisibleItems={isMobile ? 10 : 8}
      results={results}
      onChange={({ value }) => {
        setQuery(value);
        onSelect(undefined);
      }}
      onSelect={value => {
        const product = products.find(product => product.id === value);
        onSelect(product);
        if (isMobile) {
          setIsBottomSheetVisible(false);
          showSnackbar({
            message: 'Item added'
          });
          setQuery('');
        }
      }}
      label="Add products"
    ></ComboBox>
  );
};

export default ConsumablesAddProductsComboBox;
